<mat-card appearance="outlined">
  <mat-card-content>
    <div class="org-details">
      <div class="org-line">
        <strong>Nome:</strong>
        <span>{{ organization.value()?.name }}</span>
      </div>
      <div class="org-line">
        <strong>CNPJ:</strong>
        <span>{{ formatCNPJ(organization.value()?.cnpj ?? "") }}</span>
      </div>
      <div class="org-line">
        <strong>Data de Cadastro:</strong>
        <span>{{ organization.value()?.createdDate | date }}</span>
      </div>
    </div>
  </mat-card-content>
  <mat-card-actions>
    <button
      matButton
      color="primary"
      (click)="navigateToEditOrganization(organization.value()?.id!)"
      matTooltip="Editar Cliente"
    >
      EDITAR
    </button>
  </mat-card-actions>
  @if (organization.hasValue()) {
    <app-contract-list
      [organizationId]="organization.value().id"
      [showSubtitle]="false"
    ></app-contract-list>
  }
</mat-card>
